import * as React from 'react';
import classnames from 'classnames';
import { trackEvent } from 'latitude-analytics';
import { BrokerLoginButtonWrapper, LoginButton, LoginButtonSvg } from './BrokerHeader.styled';

var BrokerLoginButton = function BrokerLoginButton(_ref) {
  var isModalActive = _ref.isModalActive,
      setIsModalActive = _ref.setIsModalActive,
      analytics = _ref.analytics;

  var handleOnClick = function handleOnClick() {
    if (trackEvent) {
      trackEvent(analytics, {
        category: 'internal-link',
        action: 'login',
        label: 'broker login',
        location: 'header'
      });
    }

    setIsModalActive(!isModalActive);
  };

  return /*#__PURE__*/React.createElement(BrokerLoginButtonWrapper, {
    className: classnames(isModalActive && 'is-active')
  }, /*#__PURE__*/React.createElement(LoginButton, {
    onClick: handleOnClick,
    className: classnames(isModalActive && 'is-active'),
    type: "button",
    "aria-label": "Broker login"
  }, /*#__PURE__*/React.createElement("div", null, "Broker Log in"), /*#__PURE__*/React.createElement(LoginButtonSvg, {
    "aria-label": "Down",
    name: isModalActive ? 'chevron-up' : 'chevron-down',
    className: "up-down-icon"
  })));
};

export default BrokerLoginButton;